/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { ThemeType } from "@packages/ui";
import { numericPixels, spacing, Text } from "@packages/ui";
import React from "react";

const baseStyles: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: numericPixels[4],
  marginBottom: spacing.xxl,
  width: spacing.full,
};

const detailStyles: Interpolation<ThemeType> = (theme: ThemeType) => ({
  color: theme.semanticColors.neutralsHigher,
});

const childrenStyles: Interpolation = {
  marginTop: spacing.s,
};

interface PaymentSectionProps {
  title: string;
  description: string;
  children?: React.ReactNode;
}

export const PaymentSection = ({
  title,
  description,
  children,
}: PaymentSectionProps) => (
  <section css={baseStyles}>
    <Text size="l" type="title">
      {title}
    </Text>
    <Text size="xl" type="detail" css={detailStyles}>
      {description}
    </Text>
    <div css={childrenStyles}>{children}</div>
  </section>
);
